import axiosInstance from "../../../../api/axiosConfig";
import type { ResearchResponse, ResearchSourceId } from "./types";

export const searchLegalSource = async (
  source: ResearchSourceId,
  query: string,
  limit = 8
): Promise<ResearchResponse> => {
  const { data } = await axiosInstance.get<ResearchResponse>(
    "/research/legal",
    { params: { source, q: query, limit } }
  );
  return data;
};
